import { GridColTypeDef, GridRenderCellParams } from "@mui/x-data-grid";
import { Tooltip } from "@mui/material";

import baseColumn from "./BaseColumn";
import { fieldLabelFormat } from "../TableUtils";

export interface TextOptions {
  fieldValues?: Record<string, string>;
  headerLabels?: Record<string, string>;
}

function textColumn(options?: TextOptions): GridColTypeDef {
  const textColumn: GridColTypeDef = {
    ...baseColumn,
    type: "string",
    width: 150,
    renderCell: (params: GridRenderCellParams) => {
      return (
        <Tooltip title={params.formattedValue}>
          <span style={{overflow: "hidden", textOverflow: "ellipsis"}}>
            {params.formattedValue}
          </span>
        </Tooltip>
      )
    }
  }
  if (options?.headerLabels) {
    textColumn.renderHeader = fieldLabelFormat(options.headerLabels);
  }
  return textColumn;
}

export default textColumn;